import { render } from "./UITextInput.vue?vue&type=template&id=4cb2d98b"
import script from "./UITextInput.vue?vue&type=script&lang=ts"
export * from "./UITextInput.vue?vue&type=script&lang=ts"
script.render = render

export default script